/**
 * The Symagic Server Task Template entity
 * @author Maarten Lensink
 */
import * as tslib_1 from "tslib";
import { Task } from './task';
/**
 * The Symagic Server Task Template entity
 */
var TaskTemplate = /** @class */ (function (_super) {
    tslib_1.__extends(TaskTemplate, _super);
    function TaskTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TaskTemplate.prototype, "Purpose", {
        get: function () {
            if (!this.purpose) {
                return 'OTHER';
            }
            return this.purpose;
        },
        set: function (value) {
            this.purpose = value;
        },
        enumerable: true,
        configurable: true
    });
    return TaskTemplate;
}(Task));
export { TaskTemplate };
